/*
 * @Author: Teemo Ding
 * @Date: 2021-06-22 14:18:33
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 10:46:34
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/DeveloperSetting/index.tsx
 */
import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import {
  deleteAccessKeyReq,
  getAccessKeys,
  getAccessKeysGenerate,
} from '@/src/request/developer';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { message } from 'antd';
import React, { Fragment, ReactNode, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Modal, Skeleton } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import AccessKey from './AccessKey';
import CreateAccessModal from './CreateAccessModal';
import AddUnit from './CreateAccessModal/AddAccessTitle';
import { breadcrumbData, columns } from './config';
const permissions = () => {
  const view_developer_setting = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsDeveloperSetting,
        operation: EnumOperation.view_developer_setting,
      }),
    ],
  });
  const create_access_key = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsDeveloperSetting,
        operation: EnumOperation.create_access_key,
      }),
    ],
  });
  const delete_access_key = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsDeveloperSetting,
        operation: EnumOperation.delete_access_key,
      }),
    ],
  });
  return {
    view_developer_setting,
    create_access_key,
    delete_access_key,
  };
};

const DeveloperSetting = () => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { view_developer_setting, create_access_key, delete_access_key } =
    permissions();
  const history = useHistory();
  const [modalTitle, setModalTitle] = useState<string | ReactNode>('');
  const [modalContent, setModalContent] = useState<string | ReactNode>('');
  const [showModal, setShowModal] = useState<boolean>(false);
  const [accessKey, setAccessKey] = useState([]);

  const goBackToList = () => {
    history.push({
      pathname: '/settings',
    });
  };

  useEffect(() => {
    if (view_developer_setting) {
      requestData();
    }
  }, []);

  const requestData = () => {
    getAccessKeys().then((response) => setAccessKey(response));
  };

  const deleteAccessKey = (record) => {
    setShowModal(true);
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        onSubmit={() => {
          deleteAccessKeyReq(record.uuid).then((data) => {
            message.success(getI18n('general.successfullydeleted'));
            requestData();
          });
        }}
        okText={getI18n('general.delete')}
        errorText={getI18n('storeDeveloperSetting.detail.deleteTip')}
      />,
    );
    setModalTitle(
      <ErrorModalTitle>
        {getI18n('general.delete')}
        {getI18n('storeDeveloperSetting.detail.accessKey')}
      </ErrorModalTitle>,
    );
  };

  const CreateAccessKey = () => {
    setShowModal(true);
    const nameList = accessKey.map((item) => item.title);
    setModalContent(
      <AddUnit
        title={`${getI18n('general.title')}*`}
        okText={getI18n('general.create')}
        cancelText={getI18n('general.discard')}
        nameList={nameList}
        defaultValue={`${getI18n('storeDeveloperSetting.detail.accessKey')} ${
          accessKey.length + 1
        }`}
        setModal={setShowModal}
        externalClose
        onSubmit={(title) => {
          getAccessKeysGenerate(title).then((data) => {
            requestData();
            setModalContent(
              <CreateAccessModal closeModal={closeModal} data={data} />,
            );
          });
        }}
      />,
    );
    setModalTitle(getI18n('storeDeveloperSetting.detail.createAccessKey'));
  };
  const closeModal = () => {
    setShowModal(false);
  };

  const topLeft = (
    <TopLeft
      goBack={goBackToList}
      breadcrumbData={breadcrumbData({ getI18n })}
    />
  );

  const Child = [
    {
      child: (
        <AccessKey
          key={1}
          CreateAccessKey={CreateAccessKey}
          accessKey={accessKey}
          columns={columns(deleteAccessKey, !delete_access_key, { getI18n })}
          disableCreate={!create_access_key}
        />
      ),
    },
  ];

  return (
    <Fragment>
      <Skeleton loading={false} active>
        <Layout elements={Child} topLeft={topLeft} />
      </Skeleton>
      <Modal
        width={600}
        title={modalTitle}
        visible={showModal}
        onCancel={() => setShowModal(false)}>
        {modalContent}
      </Modal>
    </Fragment>
  );
};

export default DeveloperSetting;
